import { render, staticRenderFns } from "./UpsellHire.vue?vue&type=template&id=1f805024&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../../@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports